const DEFAULT_TTL = 3600000; // 1 hour in milliseconds

export function getSessionStorageWithExpiry(key) {
  try {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) return null;

    const itemObj = JSON.parse(itemStr);
    if (!itemObj || !itemObj.value || !itemObj.expiry) return null;

    if (new Date().getTime() > itemObj.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }

    return itemObj.value;
  } catch {
    return null;
  }
}

export function setSessionStorageWithExpiry(key, value, ttl = DEFAULT_TTL) {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
}

export function getLocalStorageWithExpiry(key) {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    if (new Date().getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    return null;
  }
}

export function setLocalStorageWithExpiry(key, value, ttl = DEFAULT_TTL) {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };
  try {
    localStorage.setItem(key, JSON.stringify(item));
  } catch {
    // Storage quota exceeded — silently ignore
  }
}
